<template lang='pug'>
    div
        div.fullwidth(v-if="$route.params.lang == 'en'")
            div.title-container
                h1.product-title Other PD Sensors
                //- h2.notopmargin BSS offers a range of PD sensors suitable for measurements of partial discharges at cables, MV switchgears and transformers.
            
            router-link.section(to="/en/products/otherpdsensors/ae-150-m")
                .column-container
                    .column.flexgrow
                        .producttitle AE-150-M
                        .subtitle Acoustic PD Sensor
                        ul
                            li Bandwidth: 50 kHz … 400 kHz
                            li Solid borne sound sensor for acoustic PD detection
                    .column.alignright
                        picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/AE-150-M.webp')
                            img( src='@/assets/photos/product_shots/AE-150-M.png', width="100%", alt='Acoustic PD Sensor AE-150-M', title='Acoustic PD Sensor AE-150-M')

            router-link.section(to="/en/products/otherpdsensors/tev-cp")
                .column-container
                    .column.flexgrow
                        .producttitle TEV-CP
                        .subtitle Transient Earth Voltage PD Sensor
                        ul
                            li Bandwidth: 5 MHz … 100 MHz
                            li For retrofit at MV switchgears
                    .column.alignright
                        picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/TEV-CP.webp')
                            img( src='@/assets/photos/TEVSensor.png' height="100%")

        div.fullwidth(v-if="$route.params.lang == 'de'")
            div.title-container
                h1.product-title Andere Teilentladungssensoren
                //- h2.notopmargin BSS offers a range of PD sensors suitable for measurements of partial discharges at cables, MV switchgears and transformers.

            router-link.section(to="/de/products/otherpdsensors/ae-150-m")
                .column-container
                    .column.flexgrow
                        .producttitle AE-150-M
                        .subtitle Akustischer TE-Sensor
                        ul
                            li Bandbreite: 50 kHz … 400 kHz
                            li Körperschallsensor für akustische TE-Messung
                    .column.alignright
                        picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/AE-150-M.webp')
                            img( src='@/assets/photos/product_shots/AE-150-M.png', width="100%", alt='Akustischer TE-Sensor AE-150-M', title='Akustischer TE-Sensor AE-150-M')

            router-link.section(to="/de/products/otherpdsensors/tev-cp")
                .column-container
                    .column.flexgrow
                        .producttitle TEV-CP
                        .subtitle Transient Earth Voltage TE-Sensor
                        ul
                            li Bandbreite: 5 MHz … 100 MHz
                            li Zur Nachrüstung an Mittelspannungsschaltanlagen

                    .column.alignright
                        picture
                            source(type='image/webp', srcset='@/assets/photos/product_shots/TEV-CP.webp')
                            img( src='@/assets/photos/TEVSensor.png' height="100%")

</template>

<script>
export default {
    meta: {
        de: {
            title: "BSS | Andere TE-Sensoren",
            description: "Andere Teilentladungs(TE)-Sensoren von BSS-Hochspannungstechnik GmbH",
        },
        en: {
            title: "BSS | Other PD Sensors",
            description: "Other Partial Discharge (PD) Sensors of BSS-Hochspannungstechnik GmbH",
        },
    },
};
</script>

<style lang='sass' scoped>
@import '@/assets/sass/product_overview.sass'
</style>